<form
  [formGroup]="form"
  (ngSubmit)="onSubmit(form.value)"
  class="soft-form auto-height no-padding"
>
  <div class="g gtc-1 gtc-m-2 gtc-l-3 gap">
    <!-- <div class="flex flex-col gc-1 gr-1">
      <label class="soft-label soft-label-top" for="number">{{'#TICKETS.SEARCH.NUMBER' | translate}}</label>
      <soft-number-input id="number" formControlName="id"></soft-number-input>
    </div> -->
    <div class="flex flex-col gc-1 gr-2 gc-m-1-2 gr-m-2 gc-l-2-3 gr-l-1">
      <label class="soft-label soft-label-top" for="name">{{
        '#TICKETS.SEARCH.NAME' | translate
      }}</label>
      <soft-input
        type="text"
        id="name"
        formControlName="description"
        placeholder="{{ '#TICKETS.SEARCH.NAME' | translate }}"
      />
    </div>
    <div class="flex flex-col gc-1 gr-3 gc-m-2 gr-m-1 gc-l-1 gr-l-2">
      <label class="soft-label top" for="ticket-filter">{{
        '#TICKETS.SEARCH.FILTER' | translate
      }}</label>
      <soft-select id="ticket-filter" formControlName="filterId">
        @for (option of filters(); track option) {
          <soft-select-option [value]="option.id">
            {{ option.name }}
          </soft-select-option>
        }
      </soft-select>
    </div>
    <div class="flex flex-col gc-1 gr-4 gc-m-1 gr-m-3 gc-l-2 gr-l-2">
      <label class="soft-label soft-label-top">{{
        '#TICKETS.SEARCH.FROM' | translate
      }}</label>
      <soft-date-range-from-input
        formControlName="from"
        [toControl]="to"
        #from
      ></soft-date-range-from-input>
    </div>
    <div class="flex flex-col gc-1 gr-5 gc-m-2 gr-m-3 gc-l-3 gr-l-2">
      <label class="soft-label soft-label-top">{{
        '#TICKETS.SEARCH.TO' | translate
      }}</label>
      <soft-date-range-to-input
        formControlName="to"
        [fromControl]="from"
        #to
      ></soft-date-range-to-input>
    </div>
    <div class="flex flex-col gc-1 gr-6 gc-m-1 gr-m-4 gc-l-1 gr-l-3">
      <label for="fromPriority" class="soft-label top">{{
        '#TICKETS.SEARCH.FROM_PRIORITY' | translate
      }}</label>
      <soft-select formControlName="fromPriority" id="fromPriority">
        @for (option of priorities; track option) {
          <soft-select-option [value]="option">{{ option }}</soft-select-option>
        }
      </soft-select>
    </div>
    <div class="flex flex-col gc-1 gr-7 gc-m-2 gr-m-4 gc-l-2 gr-l-3">
      <label for="toPriority" class="soft-label top">{{
        '#TICKETS.SEARCH.TO_PRIORITY' | translate
      }}</label>
      <soft-select formControlName="toPriority" id="toPriority">
        @for (option of priorities; track option) {
          <soft-select-option [value]="option">{{ option }}</soft-select-option>
        }
      </soft-select>
    </div>

    <div
      class="flex flex-row justify-end items-center gc-1 gr-8 gc-m-1-2 gr-m-5 gc-l-3 gr-l-3"
    >
      <a class="soft-button mr-4 rounded hover:cursor-pointer" (click)="resetForm()">{{
        '#TICKETS.SEARCH.RESET' | translate
      }}</a>
      <button
        type="submit"
        [disabled]="form.invalid"
        class="soft-button soft-button-primary rounded hover:cursor-pointer"
      >
        {{ '#TICKETS.SEARCH.SUBMIT' | translate }}
      </button>
    </div>
  </div>
</form>
